// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type Scope } from "~/hooks/useScope";
import { SET_SPACE_MEMBERSHIP } from "./action";

export function canSetSpaceMembership(scope: Scope): boolean {
  return scope.iamActions.includes(SET_SPACE_MEMBERSHIP);
}
